module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Hamutal Bar-Yosef is a well-known Israeli writer, poet, translator and scholar. She was born in a kibbutz. When she was over 40, she wrote her PhD and became a professor of Hebrew literature at Ben-Gurion University. She published 8 scholarly books and 16 books of poetry, winning over 10 major prizes for her poetry. Her poems were translated and published in various languages, including two collections in English: "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Night, Morning")]), _vm._v(" (2017) and "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("The Ladder")]), _vm._v(" (2013).")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Her collection of stories, "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Music")]), _vm._v(", won the ASI (Association of Israeli Writers) prize (translated into English as "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("The Wall")]), _vm._v(", 2019). She translated poetry and prose fiction from English, French, Russian and Yiddish. Her prize-winning historical novel "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("The Wealthy")]), _vm._v(" has been translated into English (2022) and has received many reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bff6952","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0